import { FC, useState } from 'react';
import { NexResponsePriceMode } from '../../../../model/api/locations/NexResponsePriceMode';
import { notifications } from '../../../../services';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import styles from './ChangePriceCategoryDialog.module.scss';
import { nexResponseService } from '../../../../services/api/nexResponse';
import {Spinner} from "../../../../components/common";

interface PriceCategoryDialogProps {
  customerId: number;
  selectedLotIds: number[];
  onClose: (result?: { selectedLotIds: number[]; priceMode: NexResponsePriceMode }) => void;
  priceCategoryOptions: { text: string; value: NexResponsePriceMode }[];
  singleLotName?: string | undefined;
}

export const ChangePriceCategoryDialog: FC<PriceCategoryDialogProps> = ({ customerId, selectedLotIds, onClose, priceCategoryOptions, singleLotName }) => {
  const [selectedMode, setSelectedMode] = useState<{ text: string; value: NexResponsePriceMode }>(priceCategoryOptions[0]);
  const [busy, setBusy] = useState(false);
  
  const handleClose = () => {
    if (busy) {
      return;
    }
    onClose();
  };
  
  const handleConfirm = async () => {
    if (!selectedMode) {
      notifications.error('Please select a price category.');
    }
    setBusy(true);
    try {
      await nexResponseService.bulkSetLotPriceModelStatus(customerId, selectedLotIds, selectedMode.value);
      notifications.success(`Price Category updated for ${selectedLotIds.length === 1 ? singleLotName : selectedLotIds.length + ' locations'}.`);
      onClose({ selectedLotIds, priceMode: selectedMode.value });
    } catch (error) {
      notifications.error('Failed to update price categories.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog title={'Set Price Category'} onClose={() => handleClose()}>
      <div style={{ padding: '15px' }}>
        <p>
          You have chosen <strong>{selectedLotIds.length}</strong> items.
        </p>
        <p>This will change the price category setting for the selected location(s).</p>
        <div style={{ margin: '20px 0' }}>
          <Label style={{ display: 'block', marginBottom: '8px' }}>Select Price Category:</Label>
          <DropDownList
            data={priceCategoryOptions}
            textField='text'
            dataItemKey='value'
            value={selectedMode}
            popupSettings={{ className: styles.highZIndexPopup }}
            onChange={(e) => {
              setSelectedMode(e.target.value);
            }}
          />
        </div>
        <p>Do you wish to continue?</p>
      </div>
      {busy && (
          <div style={{ minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spinner />
          </div>
      )}
      <DialogActionsBar>
        <Button disabled={busy} onClick={() => handleClose()}>Cancel</Button>
        <Button themeColor='primary' onClick={handleConfirm} disabled={busy}>
          Confirm
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};
